import { filter, get, isNil, keys, map } from 'lodash'

const transformToUpdateIngredientAlternativeIngredientsDetailsArgs = data =>
  map(
    filter(
      keys(data.alternativeIngredients),
      dietId => !isNil(get(data.alternativeIngredients, dietId)),
    ),
    dietId => ({
      id: get(data.alternativeIngredients, dietId),
      dietId,
    }),
  )

export default transformToUpdateIngredientAlternativeIngredientsDetailsArgs
